import { Component } from '@angular/core';

@Component({
  selector: 'bst-client-overview-tab',
  templateUrl: './client-overview-tab.component.html',
  styleUrls: ['./client-overview-tab.component.scss'],
  standalone: false,
})
export class ClientOverviewTabComponent {}
